//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import DateFnsUtils from "@date-io/date-fns";
import * as moment from "moment";
import { useTranslation } from 'react-i18next';
import access from "config/access";

// custom pages
import { styles } from "./styles";
import promotion from "apis/promotion/promotion";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Fragment } from "react";

//Helpers
import {dateFormat} from "helpers/dataFormat"
import { blockInvalidCharForText } from "helpers/blockInvalidCharForText";


// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

const typeArr = [
  {
    label: "Order Line Number",
    value: "order_line_number",
  },
  {
    label: "Order ID",
    value: "order_id",
  },
  {
    label: "Loyalty Id",
    value: "loyalty_id",
  },
];

const frequencyArr = [
  {
    label: "Monthly",
    value: "MONTHLY",
  },
  {
    label: "Daily",
    value: "DAILY",
  },
];
const tierArr = [
  // { label: "CORE", value: "Core" },
  // { label: "SELECT", value: "Select" },
  { label: "ELITE", value: "Elite" },
];

export default function View(props) {
  const { state, dispatch } = useContext(Context);

  const { updateRule } = promotion();
  const history = useHistory();
  const location = useLocation();
  const classes = styles();
  const { t, i18n } = useTranslation();
  const [states, setstates] = useState({
    promotionName: "",
    promotionDescription: "",
    startDate: null,
    endDate: null,
    extendedDays: 0,
    expireDate: "",
    ranking: null,
    type: "",
    frequency: "",
    isActive: true,
    // priority:null,
    isSignature: false,
    isUnlock: false,
    data: {},
    edittedData: {},
    isEdit: false,
    loading: false,
    isLimited:false,
    limit:0,
    limitType:"",
    priority:null,
    tierRatioApplicable:true,
    isStartup:false,
    isStartupAutoRedeem:false,
    tier:null,
    isTierPromo:false
  });

  const {
    promotionName,
    promotionDescription,
    startDate,
    endDate,
    extendedDays,
    expireDate,
    ranking,
    type,
    frequency,
    isActive,
    isSignature,
    isUnlock,
    isAdjustmentPromo,
    data,
    edittedData,
    isEdit,
    loading,
    startprodate,
    isLimited,
    limit,
    limitType,
     priority,
     tierRatioApplicable,
     isStartup,
     isStartupAutoRedeem,
     tier,
     isTierPromo
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      let dataObj = location?.state?.data;
      setDataObj(dataObj);
    }
  }, []);

  const setDataObj = (dataObj) => {
    setStates({
      data: dataObj,
      promotionName: dataObj?.promotion_name,
      promotionDescription: dataObj?.promotion_description,
      startDate: dataObj?.start_date,
      endDate: dataObj?.end_date,
      extendedDays: dataObj?.extended_days,
      expireDate: dataObj?.expire_date,
      ranking: dataObj?.ranking,
      type: dataObj?.type,
      frequency: dataObj?.frequency,
      isActive: dataObj?.is_active,
      isSignature: dataObj?.signature_flag,
      isUnlock:dataObj?.unlock_flag,
      isAdjustmentPromo:dataObj?.Is_AdjustmentPromo,
      startprodate:dataObj?.start_date,
      isLimited:dataObj?.is_limit,
      limit:dataObj?.limit,
      limitType:dataObj?.limit_type,
      priority:dataObj?.priority,
      tierRatioApplicable:dataObj?.tier_ratio_applicable,
      isStartup: dataObj?.startup_flag,
      isStartupAutoRedeem: dataObj?.is_auto_redeem,
      isTierPromo: dataObj?.tier_based_promotion,
      tier:dataObj?.tier,
    });
  };

  let startTime = moment().format('YYYY-MM-DD');
  // let startTime = '2024-01-01'


  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Promotion Management", "View"],
    });
  }, []);
  
  const blockInvalidChar = (e) =>{
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
    if (e.keyCode === 38 || e.keyCode === 40) {
      e.preventDefault();
    }
  }
  // create api func
  const handleUpdateRule = async () => {
    try {
      if (Object.keys(edittedData).length === 0) {
        toast.error("Please alter atleast one field.", {
          toastId: "update-error",
        });
        setStates({ loading: false });
        return;
      }      
      if(edittedData?.startDate=="Invalid Date"||edittedData?.endDate=="Invalid Date"||edittedData?.expireDate=="Invalid Date"){
        toast.error("Invalid Date Format");
        setStates({ loading: false });
        return;
      }
      if(isLimited && (limit=="" || !limit)){
        toast.error("Please enter the Limit");
        setStates({ loading: false });
        return;
      }
      if(isLimited && (limitType=="" || !limitType)){
        toast.error("Please enter the Limit Type");
        setStates({ loading: false });
        return;
      }
      let failed = false;
      
      
      Object.keys(edittedData).map((key) => {
        const value = edittedData[key];
      
        // Skip validation for priority field
        if (key === "priority") return;
      
        if (!value && typeof value !== "boolean") {
          failed = true;
        }
      });
      
      if (failed) {
        toast.error("Cannot update empty field.", {
          toastId: "update-error-2",
        });
        setStates({ loading: false });
        return;
      }
      


      let values;
      if(edittedData?.startDate=="Invalid Date"||edittedData?.endDate=="Invalid Date"||edittedData?.expireDate=="Invalid Date"){
        toast.error("Invalid Date Format");
        setStates({ loading: false });
        return;

      }
      values = {
        ...edittedData,
        promotionId: data?.promotion_id,
      };
      if (edittedData?.startDate) {
        values = {
          ...values,
          startDate: moment(edittedData?.startDate).format("YYYY-MM-DD"),
        };
      }
      if (edittedData?.endDate) {
        values = {
          ...values,
          endDate: moment(edittedData?.endDate).format("YYYY-MM-DD"),
        };
      }
      if (edittedData?.ranking) {
        values = { ...values, ranking: parseInt(edittedData?.ranking) };
      }
      if (edittedData?.extendedDays) {
        values = {
          ...values,
          extendedDays: parseInt(edittedData?.extendedDays),
        };
      }
      if (edittedData?.expireDate) {
        values = {
          ...values,
          expireDate: moment(edittedData?.expireDate).format("YYYY-MM-DD"),
        };
      }
      if(!isLimited){
        values = {
          ...values,
          limitType:null,
          limit:null
        }

      }
      if(isSignature){
        values = {
          ...values,
          tierRatioApplicable:false,
          isStartup:false,
          isTierPromo:false,
          isStartupAutoRedeem:false,
          isUnlock:false
        }

      }
      if(isUnlock){
        values = {
          ...values,
          tierRatioApplicable:false,
          isStartup:false,
          isTierPromo:false,
          isStartupAutoRedeem:false,
          isSignature:false
        }

      }
      if( isStartup){
        values = {
          ...values,
          tierRatioApplicable:false,
          isSignature:false,
          isAdjustmentPromo:false,
          isTierPromo:false,
           isUnlock:false
        }
      }
      if(!isStartup){
        values = {
          ...values,
          isStartupAutoRedeem:false
        }
      }
      if(isTierPromo){
        values = {
          ...values,
          isSignature:false,
          isAdjustmentPromo:false,
          isStartup:false,
          isStartupAutoRedeem:false,
           isUnlock:false
        }
      }
      if (edittedData?.priority=='') {
        values = { ...values, priority: edittedData?.priority === '' ? null : parseInt(edittedData?.priority)      };
      }
      if (edittedData?.priority) {
        values = { ...values, priority: edittedData?.priority === '' ? null : parseInt(edittedData?.priority)      };
      }

      // console.log({ values });
      let res = await updateRule(values);
      if (res?.data === 1) {
        toast.success("Updated", { toastId: "rule-updated" });
        history.goBack();
      }
      setStates({ loading: false });
    } catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18 }}>
            {/* <strong> {t('Promotion ID')} :</strong> {data?.promotion_id} */}
          </span>
          
          {!isEdit && (
            <Button
              className={`${classes.createBtn} dash-1-filter-btn`}
              // disabled={!access['editAccess'][state.userInfo?.role]['view-promotion']}
              onClick={()=> {
                if(state?.userInfo?.editAction){
                  setStates({ isEdit: true });
                  return;
                }
                else{
                  toast.error(state.userInfo?.editAccess)
                  return;
                }
              }}
            >
              {t('Edit')}
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={4} style={{ padding: 10, fontSize: 16 }}>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('Promotion Name')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit && ( startTime<startprodate || state?.userInfo?.role_id == 10)  ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    onKeyDown={blockInvalidCharForText}
                    onInput={(e) => {
                      const value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, ""); 
                      if (value !== e.target.value) {
                        e.target.value = value; 
                      }
                      setStates({
                        promotionName: value,
                        edittedData: {
                          ...edittedData,
                          promotionName: value,
                        },
                      });
                    }}
                    required
                    className={classes.editInput}
                    value={promotionName}
                    
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 50) {

                      setStates({
                        promotionName: value,
                        edittedData: {
                          ...edittedData,
                          promotionName: value,
                        },
                      });
                    }
                    }}
                    error={promotionName.length === 50} // Show error when character limit is reached
                    helperText={promotionName.length === 50 ? "Promotion Name cannot exceed 50 characters" : ""}
                    inputProps={{ maxLength: 50 }}
                  />
                ) :
                <span className={classes.label}> {promotionName}</span>
              }
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>
                {t('Promotion Description')} :{" "}
              </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit &&  ( startTime<startprodate || state?.userInfo?.role_id == 10)  ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={promotionDescription}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 50) {
                      setStates({
                        promotionDescription: e.target.value,
                        edittedData: {
                          ...edittedData,
                          promotionDescription: e.target.value,
                        },
                      });
                    }
                    }}
                    error={promotionDescription.length === 50} // Show error when character limit is reached
                    helperText={promotionDescription.length === 50 ? "Promotion Description cannot exceed 50 characters" : ""}
                    inputProps={{ maxLength: 50 }}
                  />
                ) :
                <span className={classes.label}> {promotionDescription}</span>
              }
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('Start Date')}: </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit && ( startTime<startprodate || state?.userInfo?.role_id == 10)  ? (
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      inputVariant="outlined"
                      format="MM/dd/yyyy"
                      id="date-picker-inline"
                      required
                      className={classes.editInput}
                      value={startDate}
                      onChange={(date) => {
                        if (
                          moment(moment(date).format("MM/DD/YYYY")).isAfter(
                            moment(endDate).format("MM/DD/YYYY")
                          )
                        ) {
                          toast.error(
                            "Start date should be greater than End date.",
                            {
                              toastId: "start-date-error",
                            }
                          );
                          setStates({
                            startDate: null,
                            edittedData: {
                              ...edittedData,
                              startDate: null,
                            },
                          });
                          return;
                        }
                        setStates({
                          startDate: date,
                          edittedData: {
                            ...edittedData,
                            startDate: date,
                          },
                        });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      autoOk
                    />
                  </MuiPickersUtilsProvider>
                ) :
                <span className={classes.label}> {dateFormat(startDate, i18n.language)}</span>
              }
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('End Date')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    inputVariant="outlined"
                    format="MM/dd/yyyy"
                    id="date-picker-inline"
                    required
                    className={classes.editInput}
                    value={endDate}
                    onChange={(date) => {
                      if (
                        moment(moment(date).format("MM/DD/YYYY")).isBefore(
                          moment(startDate).format("MM/DD/YYYY")
                        )
                      ) {
                        toast.error(
                          "End date should be greater than start date.",
                          {
                            toastId: "end-date-error",
                          }
                        );
                        setStates({
                          // endDate: null,
                          edittedData: {
                            ...edittedData,
                            endDate: null,
                          },
                        });
                        return;
                      }
                      if (
                        moment(moment(date).format("MM/DD/YYYY")).isAfter(
                          moment(expireDate).format("MM/DD/YYYY")
                        )
                      ) {
                        toast.error(
                          "End date should be lesser  than extended  date.",
                          {
                            toastId: "end-date-error",
                          }
                        );
                        setStates({
                          endDate: null,
                          edittedData: {
                            ...edittedData,
                            endDate: null,
                          },
                        });
                        return;
                      }
                      if (
                        moment(moment(date).format("MM/DD/YYYY")).isAfter(
                          moment(expireDate).format("MM/DD/YYYY")
                        )
                      ) {
                        toast.error(
                          "End date should be lesser than extended date.",
                          {
                            toastId: "end-date-error",
                          }
                        );
                        setStates({
                          endDate: null,
                          edittedData: {
                            ...edittedData,
                            endDate: null,
                          },
                        });
                        return;
                      }
                      setStates({
                        endDate: date,
                        edittedData: {
                          ...edittedData,
                          endDate: date,
                        },
                      });
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    autoOk
                  />
                </MuiPickersUtilsProvider>
              ) : (
                <span className={classes.label}> {dateFormat(endDate, i18n.language)}</span>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('Extended Days')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {/* {isEdit ? (
                <CssTextField
                  variant="outlined"
                  type={"number"}
                  onKeyDown={blockInvalidChar}
                  className={`${classes.cssTextField} ${classes.editInput}`}
                  required
                  // className={classes.editInput}
                  value={extendedDays}
                  onChange={(e) => {
                    setStates({
                      extendedDays: e.target.value,
                      edittedData: {
                        ...edittedData,
                        extendedDays: e.target.value,
                      },
                    });
                  }}
                />
              ) : (
                <span className={classes.label}> {extendedDays}</span>
              )} */}
               <span className={classes.label}> {extendedDays}</span>
            </Grid>
          </Grid>
        </Grid>

        {/* <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('Expire Date')} : </strong>
            </Grid>
            <Grid item xs={8}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    inputVariant="outlined"
                    format="MM/dd/yyyy"
                    id="date-picker-inline"
                    required
                    className={classes.editInput}
                    value={expireDate}
                    onChange={(date) => {
                      if (
                        moment(moment(date).format("MM/DD/YYYY")).isSame(
                          moment(expireDate).format("MM/DD/YYYY")
                        )
                      ) {
                        return;
                      }
                      setStates({
                        expireDate: date,
                        edittedData: {
                          ...edittedData,
                          expireDate: date,
                        },
                      });
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    autoOk
                  />
                </MuiPickersUtilsProvider>
              <span className={classes.label}> {dateFormat(expireDate, i18n.language)}</span>
            </Grid>
          </Grid>
        </Grid> */}
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>Extended Date : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    inputVariant="outlined"
                    format="MM/dd/yyyy"
                    id="date-picker-inline"
                    required
                    className={classes.editInput}
                    value={expireDate}
                    onChange={(date) => {
                      // console.log({ expireDate, date });
                      if (
                        moment(moment(date).format("MM/DD/YYYY")).isBefore(
                          moment(endDate).format("MM/DD/YYYY")
                        )
                      ) {
                        toast.error(
                          "Extended date should be greater than end date.",
                          {
                            toastId: "end-date-error",
                          }
                        );
                        setStates({
                          expireDate: null,
                          edittedData: {
                            ...edittedData,
                            expireDate: null,
                          },
                        });
                        return;
                      }
                    
                      setStates({
                        expireDate: date,
                        edittedData: {
                          ...edittedData,
                          expireDate: date,
                        },
                      });
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    autoOk
                  />
                </MuiPickersUtilsProvider>
              ) : (
                <span className={classes.label}> {dateFormat(expireDate, i18n.language)}</span>
              )}
            </Grid>
          </Grid>
        </Grid>

        {/* <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Ranking')}: </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  type={"number"}
                  onKeyDown={blockInvalidChar}
                  required
                  className={classes.editInput}
                  value={ranking}
                  onChange={(e) => {
                    setStates({
                      ranking: e.target.value,
                      edittedData: {
                        ...edittedData,
                        ranking: e.target.value,
                      },
                    });
                  }}
                />
              ) : (
                <span className={classes.label}> {ranking}</span>
              )}
            </Grid>
          </Grid>
        </Grid> */}

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Type')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit && ( startTime<startprodate || state?.userInfo?.role_id == 10) ? (
                  <CssTextField
                    variant="outlined"
                    id={"Type"}
                    select
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={type}
                    onChange={(e) => {
                      setStates({
                        type: e.target.value,
                        edittedData: {
                          ...edittedData,
                          type: e.target.value,
                        },
                      });
                    }}
                  >
                    {typeArr.map((t, i) => (
                      <MenuItem value={t.value} key={i}>
                        {t.label}
                      </MenuItem>
                    ))}
                  </CssTextField>
                ) :
                <span className={classes.label}> {t(type)}</span>
              }
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Frequency')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit &&  ( startTime<startprodate || state?.userInfo?.role_id == 10)  ? (
                <CssTextField
                  variant="outlined"
                  id={"Frequency"}
                  select
                  type={"text"}
                  required
                  fullWidth
                  className={classes.editInput}
                  value={frequency}
                  onChange={(e) => {
                    setStates({
                      frequency: e.target.value,
                      edittedData: {
                        ...edittedData,
                        frequency: e.target.value,
                      },
                    });
                  }}
                >
                  {frequencyArr.map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}> {frequency}</span>
             )}
              
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Is Active')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Active"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={isActive}
                  onChange={(e) => {
                    setStates({
                      isActive: e.target.value,
                      edittedData: {
                        ...edittedData,
                        isActive: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "True", value: true },
                    { label: "False", value: false },
                  ].map((k, i) => (
                    <MenuItem value={k.value} key={i}>
                      {t(k.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}> {isActive.toString()}</span>
              )}
            </Grid>
          </Grid>
        </Grid>

        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && !isStartup && !isTierPromo )&&<Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Is Signature')} : </strong>
            </Grid>
            <Grid item xs={8}>
              
              {isEdit && state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental'  ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Signature"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={isSignature}
                  onChange={(e) => {
                    setStates({
                      isSignature: e.target.value,
                      edittedData: {
                        ...edittedData,
                        isSignature: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "True", value: true },
                    { label: "False", value: false },
                  ].map((k, i) => (
                    <MenuItem value={k.value} key={i}>
                      {t(k.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                
                <span className={classes.label}> {isSignature?.toString()}</span>
              )}

            </Grid>
          </Grid>
        </Grid>}
        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && !isStartup && !isTierPromo)  &&<Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Is AdjustmentPromo')} : </strong>
            </Grid>
            <Grid item xs={8}>
              
              {isEdit && state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental'  ? (
                <CssTextField
                  variant="outlined"
                  id={"Is AdjustmentPromo"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={isAdjustmentPromo}
                  onChange={(e) => {
                    setStates({
                      isAdjustmentPromo: e.target.value,
                      edittedData: {
                        ...edittedData,
                        isAdjustmentPromo: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ].map((k, i) => (
                    <MenuItem value={k.value} key={i}>
                      {t(k.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                
                <span className={classes.label}> {isAdjustmentPromo?"Yes":"No"}</span>
              )}

            </Grid>
          </Grid>
        </Grid>}
        {state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental'  &&<Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Is Limited')} : </strong>
            </Grid>
            <Grid item xs={8}>
              
              {isEdit && state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental'  ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Limited"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  disabled={isAdjustmentPromo === true}
                  value={isLimited}
                  onChange={(e) => {
                    setStates({
                      isLimited: e.target.value,
                      edittedData: {
                        ...edittedData,
                        isLimited: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ].map((k, i) => (
                    <MenuItem value={k.value} key={i}>
                      {t(k.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                
                <span className={classes.label}> {isLimited?"Yes":"No"}</span>
              )}

            </Grid>

          </Grid>
        </Grid>}
        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental'&& !isSignature && !isTierPromo && !isUnlock)  &&<Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Is Startup')} : </strong>
            </Grid>
            <Grid item xs={8}>
              
              {(isEdit && state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && !isSignature ) ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Startup"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={isStartup}
                  onChange={(e) => {
                    setStates({
                      isStartup: e.target.value,
                      edittedData: {
                        ...edittedData,
                        isStartup: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "True", value: true },
                    { label: "False", value: false },
                  ].map((k, i) => (
                    <MenuItem value={k.value} key={i}>
                      {t(k.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                
                <span className={classes.label}> {isStartup?.toString()}</span>
              )}

            </Grid>
          </Grid>
        </Grid>}
        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental'&& !isSignature && !isTierPromo &&isStartup && !isUnlock )  &&<Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Is Startup Auto Redeem')} : </strong>
            </Grid>
            <Grid item xs={8}>
              
              {(isEdit && state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && isStartup ) ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Startup Auto Redeem"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={isStartupAutoRedeem}
                  onChange={(e) => {
                    setStates({
                      isStartupAutoRedeem: e.target.value,
                      edittedData: {
                        ...edittedData,
                        isStartupAutoRedeem: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "True", value: true },
                    { label: "False", value: false },
                  ].map((k, i) => (
                    <MenuItem value={k.value} key={i}>
                      {t(k.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                
                <span className={classes.label}> {isStartupAutoRedeem?.toString()}</span>
              )}

            </Grid>
          </Grid>
        </Grid>}
          {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && !isStartup && !isTierPromo )&&<Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Is Unlock')} : </strong>
            </Grid>
            <Grid item xs={8}>
              
              {isEdit && state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental'  ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Unlock"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={isUnlock}
                  onChange={(e) => {
                    setStates({
                      isUnlock: e.target.value,
                      edittedData: {
                        ...edittedData,
                        isUnlock: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "True", value: true },
                    { label: "False", value: false },
                  ].map((k, i) => (
                    <MenuItem value={k.value} key={i}>
                      {t(k.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                
                <span className={classes.label}> {isUnlock?.toString()}</span>
              )}

            </Grid>
          </Grid>
        </Grid>}
        
        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' &&!isSignature && !isStartup && !isUnlock) &&<Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Tier Ratio Applicable')} : </strong>
            </Grid>
            <Grid item xs={8}>
              
              {(isEdit && state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && !isSignature && !isUnlock) ? (
                <CssTextField
                  variant="outlined"
                  id={"Tier Ratio Applicable"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={tierRatioApplicable}
                  onChange={(e) => {
                    setStates({
                      tierRatioApplicable: e.target.value,
                      edittedData: {
                        ...edittedData,
                        tierRatioApplicable: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ].map((k, i) => (
                    <MenuItem value={k.value} key={i}>
                      {t(k.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                
                <span className={classes.label}> {tierRatioApplicable?"Yes":"No"}</span>
              )}

            </Grid>

          </Grid>
        </Grid>}
        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && !isStartup && !isSignature )&&<Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Is Tier Promo')} : </strong>
            </Grid>
            <Grid item xs={8}>
              
              {isEdit && state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental'  ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Tier Promo"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={isTierPromo}
                  onChange={(e) => {
                    setStates({
                      isTierPromo: e.target.value,
                      edittedData: {
                        ...edittedData,
                        isTierPromo: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "True", value: true },
                    { label: "False", value: false },
                  ].map((k, i) => (
                    <MenuItem value={k.value} key={i}>
                      {t(k.label)}
                    </MenuItem>
                  ))}
                </CssTextField>   
              ) : (
                
                <span className={classes.label}> {isTierPromo?.toString()}</span>
              )}

            </Grid>
          </Grid>
        </Grid>}
        {(state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && isTierPromo && !isStartup && !isSignature && !isAdjustmentPromo && !isUnlock)&&<Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Promotional Tier')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit && state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental'  ? (
                  <CssTextField
                    variant="outlined"
                    id={"Promotional Tier"}
                    select
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={tier}
                    onChange={(e) => {
                      setStates({
                        tier: e.target.value,
                        edittedData: {
                          ...edittedData,
                          tier: e.target.value,
                        },
                      });
                    }}
                  >
                    <MenuItem value="">
                        {t("Select Promotional Tier")}
                      </MenuItem>
                    {tierArr.map((t, i) => (
                      <MenuItem value={t.value} key={i}>
                        {t.label}
                      </MenuItem>
                    ))}
                  </CssTextField>
                  ) :
                <span className={classes.label}> {t(tier)}</span>
              }
          </Grid>
        </Grid>
        </Grid>}

        {isLimited  &&<Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Limit Type')} : </strong>
            </Grid>
            <Grid item xs={8}>
              
              {isEdit && state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental'  ? (
                <CssTextField
                  variant="outlined"
                  id={"Limit Type"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={limitType}
                  onChange={(e) => {
                    setStates({
                      limitType: e.target.value,
                      edittedData: {
                        ...edittedData,
                        limitType: e.target.value,
                      },
                    });
                  }}
                >
                   {[
              { label: "Shipto", value: 'customer_account_number' },
              { label: "Billto", value: 'customer_billto_account_number' },
              { label: "Loyalty Id", value: 'loyalty_id' },

            ].map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
                </CssTextField>
              ) : (
                
                <span className={classes.label}> {limitType}</span>
              )}

            </Grid>
            
          </Grid>
        </Grid>}
        {isLimited  &&<Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Limit')} : </strong>
            </Grid>
            <Grid item xs={8}>
              
              {isEdit && state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental'  ? (
                <CssTextField
                variant="outlined"
                type={"number"}
                
              onWheel={(e) => e.target.blur()}
                onKeyDown={blockInvalidChar}
                  required
                  className={classes.editInput}
                value={limit}
                onChange={(e) => {
                  const input = e.target.value;
                  const value = input === "" ? "" : Number(input);
                  if ((value === "" || value > 0 )) {
                  setStates({
                    
                    limit:value,
                    edittedData: {
                      ...edittedData,
                      limit: value,
                    },
                  });
                }
                }}
              />
              ) : (
                
                <span className={classes.label}> {limit}</span>
              )}

            </Grid>
            
          </Grid>
        </Grid>}
        { state?.userInfo?.role_id == 10  &&<Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}> {t('Priority')} : </strong>
            </Grid>
            <Grid item xs={8}>
              
              {isEdit && state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental'  ? (
                <CssTextField
                variant="outlined"
                type={"number"}
              onWheel={(e) => e.target.blur()}
                onKeyDown={blockInvalidChar}
                  required
                  className={classes.editInput}
                value={priority}
                onChange={(e) => {
                  const input = e.target.value;
                  const value = input === "" ? "" : Number(input);
                  if ((value === "" || value > 0 )) {
                  setStates({
                    
                    priority:value,
                    edittedData: {
                      ...edittedData,
                      priority: value,
                    },
                  });
                }
                }}
              />
              ) : (
                
                <span className={classes.label}> {priority}</span>
              )}

            </Grid>
            
          </Grid>
        </Grid>}
        <Grid item xs={6}>
          <Grid container spacing={0}>
        {/* <Grid item xs={4}>
              <strong className={classes.label}>Priority : </strong>
            </Grid> */}
        {/* <Grid item xs={8}>
               {isEdit ? (
                <CssTextField
                  variant="outlined"
                  type={"number"}
                  onKeyDown={blockInvalidChar}
                    required
                    className={classes.editInput}
                  value={priority}
                  onChange={(e) => {
                    const input = e.target.value;
                    const value = input === "" ? "" : Number(input);
                    if ((value === "" || value > 0 )) {
                    setStates({
                      
                      priority:value,
                      edittedData: {
                        ...edittedData,
                        priority: value,
                      },
                    });
                  }
                  }}
                />
              ) : (
                <span className={classes.label}> {priority}</span>
              )} 
              
            </Grid> */}
      </Grid>
      </Grid>
      </Grid>

      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          {isEdit && (
            <Fragment>
              <Button
                className={classes.cancelBtn}
                onClick={() => {
                  setDataObj(data);
                  setStates({ isEdit: false, edittedData: {} });
                }}
              >
                {t('Cancel')}
              </Button>
              &nbsp; &nbsp; &nbsp;
              <Button
                className={classes.submitBtn}
                onClick={() => {
                  setStates({ loading: true });
                  handleUpdateRule();
                }}
                disabled={loading}
              >
                {t('Update')}
              </Button>
            </Fragment>
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
